import { ApiError, Unauthenticated } from '../../../api.js';
import { viewFetch } from '../../../view-as.js';
import { withDeadline } from '../../deadline.js';
import type { Sources } from '../contract.js';
export type { Sources };
// GET /api/admin/access: apps/api/src/routes/admin-access.ts:401, shaped at :125. lockedForYou is the MA2 AccessAdditions field.
export interface People { people: Array<{ principalId: string; displayName: string; lockedForYou?: string | null }> }
export const SOURCES_PATH = '/api/admin/connectors?shape=people';
async function json<T>(response: Response): Promise<T> {
  if (response.status === 401) throw new Unauthenticated();
  if (!response.ok) {
    const body = await response.json().catch(() => ({})) as { error?: unknown };
    throw new ApiError(response.status, typeof body.error === 'string' ? body.error : response.statusText);
  }
  if (response.status === 204) return undefined as T;
  const text = await response.text();
  return text ? JSON.parse(text) as T : undefined as T;
}
export function read<T>(store: string, path: string, signal?: AbortSignal): Promise<T> {
  return withDeadline(`${path}${path.includes('?') ? '&' : '?'}store=${encodeURIComponent(store)}`, { credentials: 'same-origin' }, json<T>, signal);
}
export async function write<T>(store: string, path: string, method: 'POST' | 'PATCH' | 'PUT', body: object): Promise<T> {
  return json<T>(await viewFetch(path, { method, credentials: 'same-origin', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ store, ...body }) }));
}
export const getSources = (store: string, signal?: AbortSignal) => read<Sources>(store, SOURCES_PATH, signal);
export const getPeople = (store: string, signal?: AbortSignal) => read<People>(store, '/api/admin/access', signal);
// The source write contract specifies no response body; refresh the canonical read.
// One literal path per verb, so the admin map can match each call to its row.
export const changeSource = (store: string, connectorId: string, verb: 'pause' | 'resume', reason: string) =>
  verb === 'pause'
    ? write<void>(store, `/api/admin/sources/${encodeURIComponent(connectorId)}/pause`, 'POST', { reason })
    : write<void>(store, `/api/admin/sources/${encodeURIComponent(connectorId)}/resume`, 'POST', { reason });

// Home Action.kind=post uses a server-supplied path and confirmation; all MA5 writes require a reason.
export const postAction = (store: string, path: string, reason: string) => write<{ done?: string } | undefined>(store, path, 'POST', { reason });
